import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel'
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';


const Supplier = ({
    onUpdateSupplierIdSelected,
    supplierIdSelected,
    supplierListFilter,
    onUpdateReloadListSupplier
}) => {
    const [idSupplier, setIdSupplier] = useState(null);
    const [supplierName, setSupplierName] = useState(null);
    const [cnpj, setCnpj] = useState(null);
    const [cityRegistration, setCityRegistration] = useState(null);
    const [stateRegistration, setStateRegistration] = useState(null);
    const [address, setAddress] = useState(null);
    const [addressNumber, setAddressNumber] = useState(null);
    const [complement, setComplement] = useState(null);
    const [neighborhood, setNeighborhood] = useState(null);
    const [city, setCity] = useState(null);
    const [cep, setCep] = useState(null);
    const [email, setEmail] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [isActive, setIsActive] = useState('S');
    const [username, setUsername] = useState(null);
    const [dtUpdate, setDtUpdate] = useState(null);

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);

    const [loadingSupplierPanel, setLoadingSupplierPanel] = useState(null);
    const [recordsSupplierGrid, setRecordsSupplierGrid] = useState(null);
    const [attributesDetailSupplierPanel, setAttributesDetailSupplierPanel] = useState(null);

    const readOnlyAttributes = !(inserting || updating);

    const attributeList = [
        { name: "id", value: idSupplier, setter: setIdSupplier },
        { name: "supplierName", value: supplierName, setter: setSupplierName },
        { name: "cnpj", value: cnpj, setter: setCnpj, width: '160px' },
        { name: "cityRegistration", value: cityRegistration, setter: setCityRegistration },
        { name: "stateRegistration", value: stateRegistration, setter: setStateRegistration },
        { name: "address", value: address, setter: setAddress },
        { name: "addressNumber", value: addressNumber, setter: setAddressNumber },
        { name: "complement", value: complement, setter: setComplement },
        { name: "neighborhood", value: neighborhood, setter: setNeighborhood },
        { name: "city", value: city, setter: setCity },
        { name: "cep", value: cep, setter: setCep },
        { name: "email", value: email, setter: setEmail },
        { name: "phoneNumber", value: phoneNumber, setter: setPhoneNumber },
        {
            name: "isActive",
            value: isActive,
            setter: setIsActive,
            resetValue: 'S',
            checks: [
                { field: 'isActive', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        { name: "username", value: username, setter: setUsername },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate }
    ];

    useEffect(() => {
        if (supplierListFilter && supplierListFilter.length > 0) {
            setRecordsSupplierGrid(supplierListFilter)
        }
    }, [supplierListFilter]);

    useEffect(() => {
        if ((!supplierIdSelected || supplierIdSelected.length != 1) && updating) {
            setUpdating(false)
        }

        if (!supplierIdSelected || supplierIdSelected.length > 1) {
            onUpdateSupplierIdSelected([])
        }
    }, [inserting, updating]);


    useEffect(() => {
        if (supplierIdSelected && supplierIdSelected.length === 1) {
            fetchDataDetail(supplierIdSelected[0]);
        } else {
            fetchDataDetail(null);
        }
    }, [supplierIdSelected]);

    const supplierPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '80%'
    };

    const fetchDataDetail = async (supplierIdSelected) => {
        const parameters = { id: supplierIdSelected ? supplierIdSelected : 0 }
        const supplier = await ExecuteAxios.api('get', `/supplier/get-supplier-detail/`, { params: parameters })
        if (supplier) {
            setAttributesDetailSupplierPanel(supplier)
            ApplyAttributes.applyAttributes(supplier, attributeList)
        }

        if (!supplierIdSelected || supplierIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    const getSupplierPanelListOrDetail = () => {
        if (!inserting && !updating) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={onUpdateSupplierIdSelected}
                    idsSelected={supplierIdSelected}
                    data={recordsSupplierGrid}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={attributesDetailSupplierPanel}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            )
        }
    }

    async function postSupplier() {
        try {
            setLoadingSupplierPanel(true)
            const response = await ExecuteAxios.api('post', `/supplier/`, {
                supplierName: supplierName,
                cnpj: cnpj,
                cityRegistration: cityRegistration,
                stateRegistration: stateRegistration,
                address: address,
                addressNumber: addressNumber,
                complement: complement,
                neighborhood: neighborhood,
                city: city,
                cep: cep,
                email: email,
                phoneNumber: phoneNumber,
                isActive: isActive
            });

            if (response) {
                onUpdateReloadListSupplier(true)
            }

            return response;
        } finally {
            setLoadingSupplierPanel(false)
        }
    }

    async function putSupplier() {
        try {
            setLoadingSupplierPanel(true)
            const response = await ExecuteAxios.api('put', `/supplier/`, {
                id: idSupplier,
                supplierName: supplierName,
                cnpj: cnpj,
                cityRegistration: cityRegistration,
                stateRegistration: stateRegistration,
                address: address,
                addressNumber: addressNumber,
                complement: complement,
                neighborhood: neighborhood,
                city: city,
                cep: cep,
                email: email,
                phoneNumber: phoneNumber,
                isActive: isActive
            });

            if (response) {
                onUpdateReloadListSupplier(true)
            }

            return response;
        } finally {
            setLoadingSupplierPanel(false)
        }
    }


    return (
        <LoadingIndicator loaded={!loadingSupplierPanel}>
            <Panel
                style={supplierPanelStyle}
                titlePage={'Fonecedor'}
                setUpdating={setUpdating}
                setInserting={setInserting}
                inserting={inserting}
                updating={updating}
                enableEdit={true}
                canEdit={supplierIdSelected && supplierIdSelected.length === 1}
                putFunction={putSupplier}
                enableNewRecord={true}
                canNewRecord={true}
                postFunction={postSupplier}
                deleteFunction={false}
                canViewCRUD={true}
                readOnly={false}
                recordsSelected={supplierIdSelected}
                viewOnlyOneRecordCRUD={true}
                resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                dataListedAttributes={attributesDetailSupplierPanel}
                attributeList={attributeList}
                onUpdateIdSelected={onUpdateSupplierIdSelected}
            >
                {getSupplierPanelListOrDetail()}
            </Panel>
        </LoadingIndicator>
    );

}

export default Supplier;